import { SET_EDITABLE_MODE,
    SET_ALERT_TYPES,
    UPDATE_ALERT_PREFERENCES_LIST,
    FETCH_ALERT_TYPES,
    SET_COMMUNICATION_PREFERENCES,
    FETCH_COMMUNICATION_PREFERENCES_MASKED,
    FETCH_COMMUNICATION_PREFERENCES_UNMASKED,
    FETCH_COMMUNICATION_PREFERENCES_FAILED,
    FETCH_COMMUNICATION_PREFERENCES_SUCCESS,
    SET_ALERT_TYPES_FAILED,
    SET_ALERT_TYPES_SUCCESS,
    RESET_COMMUNICATION_PREFERENCES,
    RESET_ALERT_PREFERENCES,
    CLEAR_ALERT_PREFERENCES,
    SET_PREFERECES_DETAILS,
    SET_LANGUAGE_PREFERENCES_SUCCESS,
    SET_LANGUAGE_PREFERENCES_FAILED,
    CLEAR_LANGUAGE_PREFERENCES_RESPONSE
} from '../../actions/preferencesActions';
import { PREFERENCE } from '../../constants/common';

const communicationPreferencesReducer = (state = {
    contactInfoData: null,
    validated: false,
    isInvalidEmail : false,
    alertTypes: null,
    alertPreferences: [],
    alertsUpdated: false,
    fetchContactInfoSuccess: false,
    fetchContactInfoFailed: false,
    setAlertTypesSuccess: false,
    setAlertTypesFailed: false,
    tabType: PREFERENCE.TABS.CONTACT_INFO,
    eventType: null,
    languageSaveSuccess: false,
    languageSaveFailed: false,
}, action) => {
    switch (action.type) {
        case FETCH_COMMUNICATION_PREFERENCES_MASKED: {
            let communicationPreferences = action.payload.communicationPreferences;
            return{
                ...state,
                contactInfoData : communicationPreferences,
                showSMS: action.payload.showSMS,
                validated: communicationPreferences.length ? action.payload.validationStatus : true,
                isEditable: communicationPreferences.length ? true : false,
                fetchContactInfoSuccess: false,
                fetchContactInfoFailed: false
            }
        }
        case FETCH_COMMUNICATION_PREFERENCES_UNMASKED: {
            if(action.payload && action.payload.validationStatus){
                return{
                    ...state,
                    contactInfoData : action.payload.communicationPreferences,
                    isInvalidEmail : false,
                    showSMS: action.payload.showSMS,
                    validated: true,
                    isEditable: false,
                    fetchContactInfoSuccess: false,
                    fetchContactInfoFailed: false
                }
            } else{
                return {
                    ...state,
                    isInvalidEmail : true,
                    isEditable: true,
                    fetchContactInfoSuccess: false,
                    fetchContactInfoFailed: false
                }
            }
        }
        case FETCH_COMMUNICATION_PREFERENCES_FAILED: {
            return {
                ...state,
                fetchContactInfoFailed: true
            }
        }
        case FETCH_COMMUNICATION_PREFERENCES_SUCCESS: {
            return {
                ...state,
                fetchContactInfoSuccess: true
            }
        }
        case SET_COMMUNICATION_PREFERENCES: {
            return {
                ...state,
                contactInfoData: action.payload,
                isEditable: true,
                fetchContactInfoSuccess: false,
                fetchContactInfoFailed: false
            }
        }
        case SET_EDITABLE_MODE: {
            if (action.isSso) {
                state = {
                    ...state,
                    validated: true
                }
            }
            return {
                ...state,
                isEditable: false,
                fetchContactInfoSuccess: false,
                fetchContactInfoFailed: false
            }
        }
        case RESET_COMMUNICATION_PREFERENCES: {
            return {
                ...state,
                fetchContactInfoSuccess: false,
                fetchContactInfoFailed: false
            }
        }
        case FETCH_ALERT_TYPES: {
            return {
                ...state,
                alertTypes : action.payload,
                alertsUpdated: false
            }
        }
        case UPDATE_ALERT_PREFERENCES_LIST: {
            return {
                ...state,
                alertPreferences: action.payload,
                alertsUpdated: false
            }
        }
        case SET_ALERT_TYPES: {
            return {
                ...state,
                alertsUpdated: true
            }
        }
        case SET_ALERT_TYPES_FAILED: {
            return {
                ...state,
                setAlertTypesFailed: true,
                alertsUpdated: false
            }
        }
        case SET_ALERT_TYPES_SUCCESS: {
            return {
                ...state,
                setAlertTypesSuccess: true,
                alertsUpdated: false
            }
        }
        case RESET_ALERT_PREFERENCES: {
            return {
                ...state,
                setAlertTypesFailed: false,
                setAlertTypesSuccess: false,
                eventType: null
            }
        }
        case CLEAR_ALERT_PREFERENCES: {
            return {
                ...state,
                alertTypes: null,
                alertPreferences: [],
                alertsUpdated: false,
                fetchContactInfoSuccess: false,
                fetchContactInfoFailed: false,
                setAlertTypesSuccess: false,
                setAlertTypesFailed: false,
            };
        }
        case SET_PREFERECES_DETAILS: {
            return {
                ...state,
                tabType: action.payload ? action.payload.tabType : state.tabType,
                eventType: action.payload ? action.payload.eventType : null
            }
        }
        case SET_LANGUAGE_PREFERENCES_SUCCESS: {
            return {
                ...state,
                languageSaveSuccess: true,
                languageSaveFailed: false,
            }
        }
        case SET_LANGUAGE_PREFERENCES_FAILED: {
            return {
                ...state,
                languageSaveSuccess: false,
                languageSaveFailed: true
            }
        }
        case CLEAR_LANGUAGE_PREFERENCES_RESPONSE: {
            return {
                ...state,
                languageSaveSuccess: false,
                languageSaveFailed: false
            }
        }
        default:
            break;
    }
    return state;
}

export default communicationPreferencesReducer;
